import client from './client';
import type { TelegramLink, TelegramStatus } from '../types/telegram';

export async function generateTelegramLink(): Promise<TelegramLink> {
  const { data } = await client.post('/telegram/generate-link');
  return data;
}

export async function getTelegramStatus(): Promise<TelegramStatus> {
  const { data } = await client.get('/telegram/status');
  return data;
}

export async function unlinkTelegram(): Promise<void> {
  await client.delete('/telegram/unlink');
}
